module.exports = "<div class=\"modal-header\">\n    <h2>{{ \"services.activations.buttons.activate.modal.title\" | translate}}</h2>\n</div>\n<p> </p>\n<p>Configurazione del vas eseguita con successo !</p>\n<footer>\n    <button class=\"button\" ng-click=\"okFunc()\"> {{ \"services.activations.buttons.activate.modal.button\" | translate}} </button>\n</footer>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/taxation/settings/SavedWithSuccessModal.html
 ** module id = 486
 ** module chunks = 0
 **/